import { IsBoolean } from 'class-validator';
import Stripe from 'stripe';
import { ICartV2 } from './cart.dto';
import { IAddress, IPharmacyAddress } from './common.dto';
import { ICheckoutPaymentMethod, IPaymentMethod } from './customer.dto';
import { IOrder } from './order.dto';
import { PaymentGatewayIntentResult } from './payment/gateway';

export class SetTransferOutCartDto {
  @IsBoolean()
  transferOut: boolean;
}

/** Server-resolved JJC transfer-out mode. Clients must not re-derive this from cart.extras. */
export class ICheckoutTransferOutState {
  active: boolean;
  /** True when the flat visit fee applies. Null when transfer-out is not active. */
  chargesFlatFee: boolean | null;
}

export class ICheckoutSession {
  _id: string; // same as cart._id
  cart: ICartV2; // cart.totalAmount reflects final amount after all discounts, credits, and gift cards
  couponCode?: string;
  totalAmountAfterCredit?: number;
  availableCreditAmount?: number;
  creditUsedAmount?: number;
  delayedCaptureAmount?: number;
  error?: string; // non fatal error; mostly validation error
  giftCardCode?: string; // gift card code applied at checkout
  giftCardUsedAmount?: number; // amount being used from gift card for this checkout
  couponError?: string; // error message for coupon validation
  transferOut?: ICheckoutTransferOutState;
}

export class ICheckoutStartResponseDTO extends ICheckoutSession {
  currency: string;
  paymentMethods: IPaymentMethod[];
  clientSecret?: string;
  paymentIntentId?: string;
  paymentStatus?: string;
  // shippingAddresses: IAddress[];
}

export class ICheckoutFinalizeRequestDTO {
  paymentMethod: ICheckoutPaymentMethod;
  shippingAddress?: IAddress;
  isNewShippingAddress?: boolean;
  transferOut?: boolean;
  pharmacyAddress?: IPharmacyAddress;
  couponCode?: string;
  assignedToGroup?: string;
  giftCardCode?: string; // gift card code to use for payment
}

export interface ICheckoutPaymentResponseDTO {
  intent:
    | Stripe.SetupIntent
    | Stripe.PaymentIntent
    | PaymentGatewayIntentResult;
  order?: IOrder;
}

export interface ICheckoutPaymentRequestDTO {
  pharmacyId?: string;
  returnUrl: string;
  paymentMethodId?: string; // optional: ignored if cart.paymentIntentId is set
  /** Whop setup-mode completion id; lets the server verify/stamp member before charging payt_… */
  setupIntentId?: string;
  shippingAddress?: IAddress; // optional: not required when all products are digital
  pharmacyAddress?: IPharmacyAddress;
  transferOut?: boolean;
  couponCode?: string;
  isNewShippingAddress?: boolean;
  assignedToGroup?: string;
  afterRedirect?: boolean;
  giftCardCode?: string; // gift card code to use for payment
}
